import React from 'react'
import styled from 'styled-components'

import { mediaQuery } from '@hozana/styling/responsive'

import { TContent, TTransformer, TTransformerOptions, convertHtmlStringToReactComponents } from '../functions'

export const PubliAndCommunityStyledDiv = styled.div`
  font-size: 17px; // 17px nunito = 16px OpenSans
  line-height: 1.45em;
  color: #222;
  font-family: ${(props) => props.theme.fontFamily.openSans};
  background-color: none;

  & * {
    hyphens: auto;
    word-wrap: break-word;
    word-break: break-word;
  }

  /* Commons */
  & img,
  & video,
  & iframe {
    max-width: 100%;
    padding: 0;
    margin-bottom: 16px;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  & #youtube-placeholder img {
    border-radius: 0px;
  }
  & img {
    border-radius: 16px;
  }

  & div,
  & p {
    margin-bottom: 8px;
    text-align: initial;
  }

  & p,
  & div,
  & em,
  & pre,
  & li,
  & span {
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
    color: ${(props) => props.theme.colors.secondaryTextContrastHigh};
    padding: 0;
    white-space: normal;
  }

  & em {
    font-style: italic;
  }

  & p span,
  & div span,
  & .hoz_quote p,
  & .hoz_important p {
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    padding: 0;
    margin: 0;
  }

  & p em,
  & div em {
    font-style: italic;
  }

  /* A */
  & div a,
  & div a span,
  & p a,
  & ul li a,
  & ol li a,
  & p a span {
    font-size: 17px;
    line-height: 28px;
    color: ${(props) => props.theme.colors.link};
    font-weight: normal;
    transition: 0.2s;
    padding: 0;
    pointer-events: auto;
    text-decoration: none;
  }

  & div a:hover,
  & div a span:hover,
  & p a:hover,
  & ul li a:hover,
  & ol li a:hover,
  & p a span:hover {
    color: ${(props) => props.theme.colors.darkBlue};
    text-decoration: underline;
  }

  & .hoz_quote {
    display: block;
    /* colors */
    color: ${(props) => props.theme.colors.secondaryTextContrastHigh};
    border-color: ${(props) => props.theme.colors.secondaryTextContrastLow};
    border-width: 0 0 0 2px;
    border-style: solid;
    /* spacing */
    margin-bottom: 16px;
    padding: 0 0 0 16px;
    /* text */
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
    font-style: italic;
  }

  & .hoz_quote em {
    color: ${(props) => props.theme.colors.black70};
    font-family: ${(props) => props.theme.fontFamily.openSans};
  }

  & .hoz_important {
    display: block;
    /* colors */
    color: ${(props) => props.theme.colors.primaryTextContrastDefault};
    background: ${(props) => props.theme.colors.whiteOrange};
    border-radius: ${(props) => props.theme.borderRadius.big};
    border: none;
    /* spacing */
    margin: 16px 0 12px 0;
    padding: 16px;
    /* text */
    font-weight: bold;
    font-size: 17px;
    line-height: 28px;
    font-family: ${(props) => props.theme.fontFamily.openSans};
  }

  & .hoz_important a {
    font-family: ${(props) => props.theme.fontFamily.openSans} !important;
  }
  & .hoz_important em {
    color: ${(props) => props.theme.colors.yellow} !important;
    font-style: normal !important;
  }

  & .hoz_important a,
  & .hoz_quote a {
    font-size: 17px !important;
    line-height: 28px !important;
    color: ${(props) => props.theme.colors.link} !important;
    font-weight: bold !important;
  }
  & .hoz_important a:hover,
  & .hoz_quote a:hover {
    color: ${(props) => props.theme.colors.darkBlue} !important;
  }

  & ul,
  & ol {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 20px;
    text-align: initial;
    list-style: initial;
  }

  & iframe {
    max-height: 500px; // #iframeMaxHeight
    width: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 a,
  h2 a,
  h3 a,
  h4 a,
  h5 a,
  h6 a {
    font-family: ${(props) => props.theme.fontFamily.openSans};
    font-style: normal;
    color: ${(props) => props.theme.colors.darkBlue};
    line-height: 28px;
    margin-right: 0;
    margin-left: 0;
    margin-top: 24px;
    margin-bottom: 16px;
    padding: 0;
    font-weight: bold;

    font-size: 24px;
    ${mediaQuery('sm')} {
      font-size: 24px;
    }
    ${mediaQuery('md')} {
      font-size: 24px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  h1 u,
  h2 u,
  h3 u,
  h4 u,
  h5 u,
  h6 u,
  h1 a,
  h2 a,
  h3 a,
  h4 a,
  h5 a,
  h6 a {
    text-decoration: none;
  }

  h1:not(.hoz_important) a,
  h2:not(.hoz_important) a,
  h3:not(.hoz_important) a,
  h4:not(.hoz_important) a,
  h5:not(.hoz_important) a,
  h6:not(.hoz_important) a {
    pointer-events: none;
    cursor: default;
    font-weight: bold;
  }

  h1,
  h1 strong,
  h1 b,
  h2,
  h2 strong,
  h2 b,
  h3,
  h3 strong,
  h3 b {
    font-weight: bold;
  }

  p + h1,
  div + h1,
  strong + h1,
  em + h1,
  a + h1,
  b + h1,
  ul + h1,
  pre + h1,
  blocquote + h1,
  p + h2,
  div + h2,
  strong + h2,
  em + h2,
  a + h2,
  b + h2,
  ul + h2,
  pre + h2,
  blocquote + h2,
  p + h3,
  div + h3,
  strong + h3,
  em + h3,
  a + h3,
  b + h3,
  pre + h3,
  ul + h3,
  blocquote + h3 {
    margin-top: 24px;
  }

  /** To publications generated from AELF API */
  .verse_number {
    font-size: 13px;
    vertical-align: text-top;
    font-weight: bold;
    color: ${(p) => p.theme.colors.darkRed};
  }
  .liturgy {
    &_complies__parole_ref,
    &_vepres__parole_ref,
    &_laudes__parole_ref {
      font-style: italic;
    }
    &_mass {
      &__lecture_ref,
      &__gospel_ref,
      &__psalm_ref {
        font-style: italic;
      }
    }
    &_mass__gospel_verse,
    &_mass__psalm_refrain_psalmique,
    &_vepres__psalm_antienne,
    &_laudes__psalm_antienne,
    &_complies__psalm_antienne {
      font-weight: bold;
      &_intro {
        font-size: 13px;
        color: ${(p) => p.theme.colors.darkRed};
      }
    }
  }
`

export const AnnouncementStyledDiv = styled.div`
  & p,
  & div,
  & em,
  & pre,
  & li,
  & span {
    font-size: 17px;
    line-height: 28px;
    color: ${(props) => props.theme.colors.black};
    padding: 0;
    white-space: normal;
    text-align: left !important;
  }

  & em {
    font-style: italic;
  }

  & p span,
  & div span {
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
    font-weight: inherit;
    color: inherit;
    padding: 0;
    margin: 0;
  }

  & p em,
  & div em {
    font-style: italic;
  }

  /* A */
  & div a,
  & div a span,
  & p a,
  & ul li a,
  & ol li a,
  & p a span {
    font-size: 17px;
    color: ${(props) => props.theme.colors.blue};
    font-weight: bold;
    transition: 0.2s;
    padding: 0;
    pointer-events: auto;
    text-decoration: none;
  }

  & div a:hover,
  & div a span:hover,
  & p a:hover,
  & ul li a:hover,
  & ol li a:hover,
  & p a span:hover {
    color: ${(props) => props.theme.colors.darkBlue};
    text-decoration: underline;
  }

  & ul,
  & ol {
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 20px;
    text-align: initial;
    list-style: initial;
  }
`

type TExternalContentProps = {
  onClick?: React.MouseEventHandler<HTMLElement>
  content: TContent
  transformers?: TTransformer[]
  options?: TTransformerOptions
}

export const ExternalContent: TFCC<TExternalContentProps> & {
  Publication: TFCC<TExternalContentProps>
  Community: TFCC<TExternalContentProps>
  Announcement: TFCC<TExternalContentProps>
} = ({ content, transformers, options }) => <>{convertHtmlStringToReactComponents(content, transformers, options)}</>

const PubliAndCommunity = React.memo<TExternalContentProps>(({ content, onClick, options }) => (
  <PubliAndCommunityStyledDiv onClick={onClick}>
    <ExternalContent content={content} options={options} />
  </PubliAndCommunityStyledDiv>
))

const Announcement = React.memo<TExternalContentProps>(({ content }) => (
  <AnnouncementStyledDiv>
    <ExternalContent content={content} />
  </AnnouncementStyledDiv>
))

PubliAndCommunity.displayName = 'PubliAndCommunity'
Announcement.displayName = 'Announcement'

ExternalContent.Publication = PubliAndCommunity
ExternalContent.Community = PubliAndCommunity
ExternalContent.Announcement = Announcement
